import React from "react";
import "../styles/About.css";
import aboutImg from "../assets/about.jpeg";

function AboutUs() {
  return (
    <div className="about-page">

      {/* Hero Section */}
      <div className="about-hero">
        <h1>About Our Interior Studio</h1>
        <p>Designing beautiful spaces that inspire everyday living</p>
      </div>

      {/* About Company */}
      <section className="about-section container">
        <div className="about-content">
          <div className="about-text">
            <h2>About Onsite Interior</h2>
            <p>
              Onsite Interior is a brand of M. Star Services, with its registered and head office located in Zirakpur, Punjab, and a brand office in Kanpur, Uttar Pradesh.

               Led by Sneha Maurya and her dedicated team, Onsite Interior is committed to delivering high-quality interior solutions with professionalism and precision.
            </p>

            <p>
              We offer flexible interior services — both on labour rate and with complete material solutions — tailored to meet diverse client needs.

              We specialize in modular kitchen design and execution, creating functional, stylish, and modern kitchen spaces that enhance your lifestyle.
            </p>
          </div>

          <div className="about-image">
             <img src={aboutImg} alt="Interior Design" />
           </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mission-section container">
        <div className="mission-box">
          <h3>Our Mission</h3>
          <p>
            To create inspiring interiors that blend comfort, aesthetics, and
            functionality while maintaining the highest standards of quality
            and innovation.
          </p>
        </div>

        <div className="mission-box">
          <h3>Our Vision</h3>
          <p>
            To become a trusted interior design brand known for creativity,
            excellence, and client satisfaction in every project we deliver.
          </p>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-us container">
        <h2>Why Choose Us</h2>

        <div className="why-grid">
          <div className="why-box">
            <h4>Creative Designs</h4>
            <p>Unique and modern designs tailored to your style.</p>
          </div>

          <div className="why-box">
            <h4>Experienced Team</h4>
            <p>Professional designers with years of industry experience.</p>
          </div>

          <div className="why-box">
            <h4>Quality Materials</h4>
            <p>We use premium materials for long-lasting interiors.</p>
          </div>

          <div className="why-box">
            <h4>Customer Satisfaction</h4>
            <p>Your happiness is our top priority in every project.</p>
          </div>
        </div>
      </section>

    </div>
  );
}

export default AboutUs;
